module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1208.48e73f1e.png";